import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoBFramesInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';

const VideoBFramesInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ count, setCount ] = useState<number>(project.encoder.transcoderVideoBFrames);
  const debounce = 100;
  const min = -1;
  const max = 8;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = count;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setCount(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoBFrames: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoBFrames: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setCount(project.encoder.transcoderVideoBFrames);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.transcoderVideoBFrames]);

  return (
    <div className="video-b-frames-input">
      <div className="input-title">{t('producer.inputs.video-b-frames.title')}</div>
      <TextInput
        placeholder="producer.inputs.video-b-frames.placeholder"
        value={count.toString()}
        onChange={(value) => {setCount(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.video-b-frames.footer')}</div>
    </div>
  );
};

export default React.memo(VideoBFramesInput);
